import { render, staticRenderFns } from "./RegulacionPantalla.vue?vue&type=template&id=3892a841&scoped=true"
import script from "./RegulacionPantalla.vue?vue&type=script&lang=js"
export * from "./RegulacionPantalla.vue?vue&type=script&lang=js"
import style0 from "./RegulacionPantalla.vue?vue&type=style&index=0&id=3892a841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3892a841",
  null
  
)

export default component.exports